<template>
  <v-container fluid class="mx-0 px-0" v-if="showNtrCheck">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #top>
        <v-toolbar flat>
          <h3 class="" style="margin-left: -15px">
            Įrašymo į NTR informacija
          </h3>
          <v-spacer></v-spacer>
          <el-button
            v-if="!readonly"
            :disabled="!canLock"
            @click.native="lockNtr(true)"
          >
            Užrakinti registrus redagavimui
          </el-button>
          <el-button
            v-if="!readonly"
            :disabled="!canUnlock"
            @click.native="lockNtr(false)"
          >
            Atrakinti registrus
          </el-button>
        </v-toolbar>
      </template>
      <template #[`item.busena`]="{ item }">
        <el-busena :busena="item.busena" :color="item.busenaColor" />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../../mixins/math'
import busena from '../../../mixins/busena'

export default {
  name: 'HipotekaNtrCheck',
  mixins: [math],
  props: {
    readonly: Boolean,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      refreshTimer: null,
      informacija: [],
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaBusena']),
    headers() {
      return [
        // {
        //   text: 'Registras',
        //   align: 'start',
        //   value: 'registras',
        // },
        {
          text: 'NT registro numeris',
          align: 'start',
          value: 'reg_nr',
        },
        {
          text: 'Turto ID',
          align: 'start',
          value: 'turtas_id',
        },
        {
          text: 'Turto pavadinimas',
          align: 'start',
          value: 'turtas_tekstas',
        },
        {
          text: 'Data',
          align: 'center',
          value: 'data',
        },
        {
          text: 'Atsakymas iš registro',
          align: 'center',
          value: 'busena',
        },
        {
          text: 'Registrą redaguojantis asmuo',
          align: 'center',
          value: 'redaguoja',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.filterItemsList.map(item => {
        item.busenaColor = 'default'
        item.redaguoja = ''

        // item.bukle = 1
        // item.statusas = 1
        // item.redaktorius = 'RŪTA STANKEVIČIENĖ'
        // item.programa = 'TURTAS'
        // item.data_redagvimo = '2021-03-26 11:11:06'

        switch (item.bukle) {
          case this.bukleTvarkomas:
            item.busena = 'Tvarkomas'
            item.busenaColor = 'red'
            item.redaguoja = `${item.redaktorius}, ${item.data_redagvimo}`
            break
          case this.bukleSutvarkytas:
            if (item.statusas === this.statusRedaguoja) {
              item.redaguoja = `${item.redaktorius}, ${item.data_redagvimo}`
              if (item.programa === this.savaPrograma) {
                item.busena = 'Užrakintas'
                item.busenaColor = 'green'
              } else {
                item.busena = 'Redaguojamas'
                item.busenaColor = 'red'
              }
            } else {
              item.busena = 'Sutvarkytas'
            }
            break
          case this.buklePanaikintas:
            item.busena = 'Panaikintas'
            item.busenaColor = 'red'
            break
          default:
            item.busena = 'Nenustatytas'
            break
        }

        return item
      })
    },
    filterItemsList() {
      return this.informacija.filter(item => {
        return item.registras === 'NTR'
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    showNtrCheck() {
      return this.filterItemsList.length > 0
    },
    savaPrograma() {
      return 'TURTAS'
    },
    statusRedaguoja() {
      return 1
    },
    bukleTvarkomas() {
      return 1
    },
    bukleSutvarkytas() {
      return 4
    },
    buklePanaikintas() {
      return 5
    },
    refreshTimeout() {
      return 10000
    },
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    canLock() {
      return (
        this.itemsList.filter(item => {
          return (
            item.bukle === this.bukleSutvarkytas &&
            item.statusas !== this.statusRedaguoja
          )
        }).length > 0
      )
    },
    canUnlock() {
      return (
        this.itemsList.filter(item => {
          return (
            item.bukle === this.bukleSutvarkytas &&
            item.statusas === this.statusRedaguoja &&
            item.programa === this.savaPrograma
          )
        }).length > 0
      )
    },
  },
  created() {
    this.getData()
    this.setRefresh()
  },
  beforeDestroy() {
    this.cancelRefresh()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`objektas/${this.objektasID}/ntr-check`)
        .then(res => {
          this.informacija = res.data.registru_informacija
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    setRefresh() {
      if (!this.isLocal && !this.isIregistruotas) {
        this.refreshTimer = setInterval(() => {
          this.getData()
        }, this.refreshTimeout)
      }
    },
    cancelRefresh() {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    },
    lockNtr(lock) {
      this.loading = true
      const data = {
        redaguojamas: lock,
      }
      this.$axios
        .post(`objektas/${this.objektasID}/ntr-registras-keisti`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
